'use client';

import { createContext, useRef, type JSX, type ReactNode } from 'react';

import type { PermissionsState } from '../stores/permissionsStore';
import { createPermissionsStore } from '../stores/permissionsStore';

export type PermissionsStoreApi = ReturnType<typeof createPermissionsStore>;

export type PermissionsStoreProviderProps = {
    children: ReactNode;
    permissionsState?: PermissionsState;
};

// TODO: Refactor this later to use the correct naming convention
// eslint-disable-next-line @typescript-eslint/naming-convention
export const PermissionsStoreContext = createContext<PermissionsStoreApi | undefined>(undefined);

export function PermissionsStoreProvider({ children, permissionsState }: PermissionsStoreProviderProps): JSX.Element {
    const storeRef = useRef<PermissionsStoreApi>(undefined);

    if (!storeRef.current) {
        storeRef.current = createPermissionsStore(permissionsState);
    } else {
        // Always sync store with current props
        storeRef.current.getState().updatePermissions(permissionsState?.permissions ?? null);
    }

    return <PermissionsStoreContext.Provider value={storeRef.current}>{children}</PermissionsStoreContext.Provider>;
}
